import styled from 'styled-components';
import { Card, CardContent, CardFooter } from 'components';

export const Container = styled.div.attrs({
  className: 'w-full h-screen flex items-center justify-center bg-background',
})``;

export const PopupCard = styled(Card).attrs({
  className: 'w-full h-screen',
})``;

export const Content = styled(CardContent).attrs({
  className: 'py-2',
})``;

export const Footer = styled(CardFooter).attrs({
  className: 'w-full justify-center',
})``;

export const HeaderContainer = styled.div.attrs({
  className: 'flex flex-col items-center justify-center gap-3 mb-3',
})``;

export const CenterStack = styled.div.attrs({
  className: 'w-full flex flex-col items-center justify-center gap-0 text-center',
})``;

export const Title = styled.p.attrs({
  className: 'text-lg leading-normal text-foreground font-semibold',
})``;

export const TitleSpacer = styled.p.attrs({
  className: 'text-lg invisible',
})``;

export const Message = styled.p.attrs({
  className: 'mt-1 text-base leading-normal text-muted-foreground',
})``;
